
import firebase from 'firebase/compat/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging } from 'firebase/messaging';
import { getDatabase } from 'firebase/database';
import config from './config/config';

// Initialize Firebase
const app = firebase.initializeApp(config.firebase);

// Initialize Firebase Analytics
const analytics = getAnalytics(app);
const db = getDatabase(app);
const messaging = getMessaging(app);
export { db, analytics, messaging };
